import React, { Component } from 'react';
import Header from '../Headers';
import SendoutTable from '../Sending-Out/sendOutTable';
// import Tables from '../Tables';
import _ from 'lodash';
import url from '../../config/url';
import generateBatch from '../../CommonFunc';
import DisplayError from '../../DisplayError';
import Singleton from '../../sock';
import { ToastContainer } from 'react-toastr';
import DownloadCsv from '../downloadCsv';

// import fetchCodeBookNo from '../fetchCode';
import axios from 'axios';
import LoaderComponent from '../cAjaxLoader';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
const fileHeaders = [
    {
        label: 'Book Number', key: 'bookNumber'
    },
    {
        label: 'Owner Branch', key: 'ownerBranch'
    },
    {
        label: 'Message', key: 'message'
    }
];
const theaders = ['Book Number', 'Owner Branch', 'Message'];
const mHeaders = ['number', 'ownerBranch', 'message'];//edit it according to json data
var batchTypeId = 0;
var bookno = [];
var swapDropdownData = [];
// var tableBody = [];
// var books = [];

class Receive extends Component {

    constructor(props) {
        super(props);
        this.state = {
            batchNumber: '',
            errorVisible: false,
            errorDesc: null,
            startListening: false,
            tData: {},
            shouldUpdate: false,
            reset: false,
            resetTableBody: false,
            showLoader: true,
            allBranches: new Array(),
            value3: '',
            disableStart:false,
            disableClear:true,
            disableReceive:true
        }
        _.bindAll(this, ['handleClear', 'handleStart', 'handleReceive', 'fetchCode', 'handleGenerate','handleNewDDChange']);
    }

    componentWillMount() {
        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    handleNewDDChange(value){
        this.setState({value3:value})
    }

    componentDidMount() {
        axios.get(url + 'generateBatchMetadata')
            .then(res => {
                var ibtBatchTypes = res.data.successObject.ibtBatchTypes;
                for (let i = 0; i < ibtBatchTypes.length; i++) {

                    if (ibtBatchTypes[i].name === 'RECEIVE') {
                        batchTypeId = ibtBatchTypes[i].id;
                    }
                }
                this.setState({ showLoader: false })
            }).catch(err => {
                console.log(err);
                this.setState({ showLoader: false })
            })
        if (swapDropdownData.length === 0) {

            axios.get(url + 'getBranchesForSwapBook').then(response => {
                // console.log('swap books data',response.data)
                if (response.data.status) {
                    var data = response.data.successObject;
                    data.forEach(element => {
                        var obj = { value: element.id, label: element.id + '-' + element.branchName }
                        swapDropdownData.push(obj);
                    });
                }
            }).catch(err => {
                console.log(err)
            })
        }
        this.setState({ allBranches: swapDropdownData });


        this.sock.onmessage = msg => {
            if (typeof (msg.data) === 'string') {
                this.fetchCode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)

                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");

        }

        // this.sock.onerror = (err) => {
        //     console.log(err);
        //     this.setState({
        //         errorVisible: true,
        //         errorDesc: "Could not connect to kiosk. Please check your connection and refresh"
        //     })
        // }

        this.sock.onclose = (evt) => {
            console.log(evt);
        }

    }
    componentWillUnmount() {
        bookno = [];
        Singleton.closeSocket(this.sock);

    }
    handleGenerate(e) {
        generateBatch(batchTypeId).then(res => {
            if (res.error) {
                this.setState({ errorVisible: true, errorDesc: res.errorDesc })
            }
            else {
                this.setState({ batchNumber: res.batchNumber })
            }
        }).catch(err => { console.log(err) })
    }

    handleStart() {
        console.log(this.state.startListening);
        this.setState({ startListening: true, disableReceive: false, disableClear: false, disableStart:true });
    }

    handleClear() {

        bookno = [];
        this.input.value = 0;
        this.setState({ tData: {}, resetTableBody: true, reset: true, disableReceive: false, disableClear: true, disableStart:false });
    }

    handleReceive() {
        this.setState({ showLoader: true })
        var uniquebooks = bookno.unique();
        var branchSelected = this.state.value3;
        console.log(branchSelected.value);
        // die;
        var dataToPost = {
            createdAt: sessionStorage.getItem('at'),
            createdBy: sessionStorage.getItem('by'),//5
            bookNumberCsv: uniquebooks.join(','),
            // ibtBatchId: batchTypeId,//Sheetal asked to change for mailers
            ibtBatchId: this.state.batchNumber,
            receiveBranch:branchSelected.value
        }
        console.log(dataToPost);

        axios.post(
            url + 'receiveBookForUtility',
            dataToPost
        ).then(response => {
            this.setState({ showLoader: false })

            if (response.data.status) {
                var tableData = [];
                var data = response.data.successObject;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status) {
                        tableData.push({
                            number: data[i].bookNumber,
                            ownerBranch: data[i].bookOwnerBranchId + "-" + data[i].bookOwnerBranchName,
                            message: data[i].Msg
                        });
                    } else {
                        tableData.push({
                            number: data[i].bookNumber,
                            ownerBranch: data[i].bookOwnerBranchId + "-" + data[i].bookOwnerBranchName,
                            message: data[i].errorMsg
                        });
                    }

                    console.log(tableData)
                    this.setState(prevState => ({
                        tData: tableData,
                        resetTableBody: !prevState.resetTableBody,
                        showLoader: false
                    }));

                }
            }
            else {
                this.refs.container.error(response.data.errorDescription)

            }
            console.log(response);
        }).catch(err => {
            console.log(err);
            this.setState({ showLoader: false })
        });

        // this.setState({showLoader:true})
        // var uniquebooks = bookno.unique();

        // var postBookData = [];
        // for (var i = 0; i < uniquebooks.length; i++) {
        //     postBookData.push({ bookNumber: uniquebooks[i] });
        // }
        // var dataToPost = {
        //     createdAt:sessionStorage.getItem('at'),
        //     createdBy:sessionStorage.getItem('by'),
        //     data: postBookData
        // }
        // console.log(dataToPost);
        // axios.post(url + 'booksReceivedByBranch', {
        //     createdAt: dataToPost.createdAt,
        //     createdBy:dataToPost.createdBy,
        //     data: dataToPost.data
        // }).then(response => {
        //     console.log(response);
        //     var successObject = response.data.successObject;
        //     console.log(successObject);
        //     if (response.data.status && successObject.length > 0) {
        //         var tableData = [];
        //         for (let i = 0; i < successObject.length; i++) {
        //             tableData.push({
        //                 number: successObject[i].bookNumber,
        //                 message: successObject[i].Msg
        //             });
        //         }
        //         this.setState(prevState => ({
        //             tData: tableData,
        //             resetTableBody: !prevState.resetTableBody,
        //             showLoader:false
        //         }));

        //     }
        //     else {
        //         this.refs.container.error(response.data.errorDescription)
        //         this.setState({ showLoader:false })

        //     }
        // })
        //     .catch(err => { console.log(err) });
    }

    fetchCode(value) {
        console.log(value)
        if (bookno.includes(value)) {
            // this.setState({ errorVisible: false, errorDesc: 'Book already added' })
            return;
        }
        else {
            bookno.push(value);
            var { tData } = this.state;
            tData.number = value;
            tData.ownerBranch = '';
            tData.message = '';

            this.setState({ tData: tData });
            // this.setState(prevState => {
            //     prevState.tData.number = value;
            //     prevState.tData.message = '';
            // })
            // this.setState({tData:{
            //     number:value,
            //     message:''
            // },errorVisible:false});
        }
        // var obj = {
        //     value: value,
        //     bookno: bookno,
        //     start: this.state.startListening,
        //     callingFrom: "sendout"
        // }

        // fetchCodeBookNo(obj).then(res => {
        //     if (res.error) {
        //         this.setState({ errorVisible: res.error, errorDesc: res.data })
        //     }
        //     else {
        //         this.setState({ errorVisible: res.error, tData: res.data });
        //     }
        //     bookno = res.bookno;
        // }).catch(err => {
        //     console.log(err);
        // })
    }

    render() {
        const { allBranches } = this.state;

        return (
            <div>
                <LoaderComponent showLoader={this.state.showLoader}>
                    <Header hname="Receive Books" />
                    <ToastContainer
                        ref="container"
                        className="toast-top-right"
                    />
                    <DisplayError
                        errorVisible={this.state.errorVisible}
                        errorDesc={this.state.errorDesc}
                    />
                    <div className="row" style={{ marginTop: 30, marginLeft: 5, marginBottom: 20 }}>
                        <div className="col-lg-4 col-sm-4 col-md-4">
                            <button className="btn" onClick={this.handleGenerate}>Batch Number</button>
                            <input type="text" style={{ marginLeft: 5, width: 60 }}
                                value={this.state.batchNumber} readOnly />

                            <label>Count
                            <input type="text" style={{ marginLeft: 5, width: 60 }} ref={(input) => this.input = input}
                                    name="count" id="count" />
                            </label>

                        </div>
                        <div className="col-lg-3 col-sm-3 col-md-3" >

                            <Select
                                name="owner-branch"
                                value={this.state.value3}
                                onChange={this.handleNewDDChange}

                                options={allBranches}
                                clearable={false}
                                placeholder='Select Branch..'
                            />
                        </div>

                        <div className="col-lg-4 col-sm-4 col-md-4" >
                            <div className=" btngroup btn-toolbar">
                                <button style={{ marginRight: 10 }} className="btn" onClick={this.handleStart} type="button"  disabled = {this.state.disableStart}>Start</button>
                                <button style={{ marginRight: 10 }} className="btn" onClick={this.handleReceive} type="button" disabled = {this.state.disableReceive}>Receive</button>
                                <button style={{ marginRight: 10 }} className="btn" onClick={this.handleClear} type="reset" disabled={this.state.disableClear}>Clear</button>
                                <DownloadCsv
                                    headers={fileHeaders}
                                    onclickCb={this.onclickCb}
                                    tableId = {"myTable"}
                                    keys = {["bookNumber","ownerBranch","message"]}
                                    filename = {`receivedBooks_${new Date().getDate()}-${new Date().getMonth()}.csv`}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-11 col-sm-11 col-md-11">
                            <SendoutTable
                                body={this.state.tData}
                                headers={theaders}
                                mHeaders={mHeaders}
                                displayCount={this.input}
                                shouldUpdate={this.state.shouldUpdate}
                                resetTable={this.state.resetTableBody}

                            />
                        </div>
                    </div>
                </LoaderComponent>
            </div>
        )
    }
}

export default Receive;


// WEBPACK FOOTER //
// ./src/Components/Receive/Receive.js